const externalLink = () => {
    document.querySelectorAll('.rich-text a[href]').forEach(link => {
        const url = link.getAttribute('href');
        // If it starts with http and is not your domain, make it open in new tab
        if (url.startsWith('http') && !url.includes(window.location.hostname)) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });

};

export default externalLink;